module.exports = __webpack_public_path__ + "img/sp.fde42529.png";